<template>
  <div class="empty-message">
    <TextBody tag="span" :i18n-key="titleKey" weight="medium" :body-type="2" />
    <TextBody tag="span" :i18n-key="descriptionKey" :body-type="2" />
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    titleKey: {
      type: String,
      default: '',
    },
    descriptionKey: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  align-self: center;

  :deep(span:first-of-type) {
    font-size: $bb-spacing-6;
    line-height: $bb-spacing-7;
  }
}
</style>
